<template>
	<div class="touchIn-cls">
		<el-form :model="touchInForm" ref="touchInForm" label-width="110px" label-position="left">
			<el-form-item label="" label-width="0">
				<div class="title-cls" prop="status">
					<span><svg-icon :icon-class="currentNode.type == '1' ? 'KnowArticle' : 'KnowProcess'" /> {{drawerType === 'create' ? '新增' : '编辑'}}{{currentNode.type == '1' ? '知识' : '流程'}}</span>
					<svg-icon @click.stop="handleClose" icon-class="KnowClose" />
				</div>
			</el-form-item>
			<el-form-item :label="currentNode.type == '1' ? '知识分类：' : '流程分类：'">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="classification" v-for="(item, index) in currentNodeNameList" :key="index">{{item.name}}</el-breadcrumb-item>
				</el-breadcrumb>
			</el-form-item>
			<el-form-item label="是否生效：">
				<el-switch
					v-model="touchInForm.status"
					active-color="#13ce66"
					inactive-color="#ff4949"
					active-value="1"
					inactive-value="2"
					active-text="生效"
					inactive-text="未生效"
					:disabled="(currentNode.right == 1 && userInfo.userType == 0)">
				</el-switch>
			</el-form-item>
			<el-form-item label="推送至公告栏：">
				<el-switch
					v-model="touchInForm.push"
					active-color="#13ce66"
					active-value="1"
					inactive-value="0"
					active-text="是"
					inactive-text="否"
					:disabled="(currentNode.right == 1 && userInfo.userType == 0)">
				</el-switch>
			</el-form-item>
			<el-form-item :label="currentNode.type == '1' ? '知识标题：' : '流程标题：'" prop="q">
				<el-input v-model="touchInForm.q" size="small" :disabled="(currentNode.right == 1 && userInfo.userType == 0)" :placeholder="currentNode.type == '1' ? '请输入知识标题...' : '请输入流程标题...'" maxlength="30" show-word-limit style="width: 300px;"></el-input>
			</el-form-item>
			<el-form-item :label="currentNode.type == '1' ? '相关知识：' : '相关流程：'" prop="relationIds">
				<el-select
					v-model="touchInForm.relationIds"
					multiple
					filterable
					remote
					reserve-keyword
					collapse-tags
					placeholder="请输入关键词"
					size="small" style="width: 300px;"
					suffix-icon="el-icon-date"
					:multiple-limit="10"
					:remote-method="remoteMethod"
					:disabled="(currentNode.right == 1 && userInfo.userType == 0)">
						<el-option
							v-for="item in relationList"
							:key="item.id"
							:label="item.q"
							:value="item.id">
						</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业务分类" prop="a.businessCategories" v-if="currentNode.type == '2' && ['relx', 'majorelstg'].includes(userInfo.brandIdentify)">
				<el-input v-model="touchInForm.a.businessCategories" size="small" :disabled="(currentNode.right == 1 && userInfo.userType == 0)" placeholder="请输入业务分类" maxlength="200" show-word-limit style="width: 300px;"></el-input>
			</el-form-item>
			<el-form-item v-if="currentNode.type == '1'" label="附件：" prop="a.appendixList">
				<el-upload
					action=""
					:http-request="(res) => { return httpRequestFile(res)}"
					:on-exceed="handleExceed"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:limit="5"
					:file-list="touchInForm.a.appendixList"
					:disabled="(currentNode.right == 1 && userInfo.userType == 0)"
					accept="
						image/png, 
						image/jpg, 
						image/jpeg, 
						image/bmp, 
						image/PNG, 
						image/JPG, 
						image/JPEG, 
						image/BMP,
						.PDF
						.pdf,
						.rar,
						.zip,
						.xls,
						.xlsx,
						.docx,
						.doc">
					<el-button :disabled="(currentNode.right == 1 && userInfo.userType == 0)" type="text">
						<svg-icon icon-class="KnowAppendix" />
						插入附件 ({{touchInForm.a.appendixList.length}}/5)
					</el-button>
					<!-- <el-divider direction="vertical"></el-divider> -->
					<!-- <span slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</span> -->
				</el-upload>
			</el-form-item>
			<el-form-item :label="currentNode.type == '1' ? '知识内容：' : '流程内容：'" prop="a">
				<template v-if="currentNode.type == '1'">
					<div class="welfare-text-cls" style="border: solid 1px #D8D8D8;">
						<WelfareText :qaValue="touchInForm.a.welfareText" @childByValue="(res) => { return childByValue(res)}" />
					</div>
				</template>
				<template v-else>
					<div class="cell" :class="{'error-tips': themeListIdDelete === item.id}" v-for="(item, index) in touchInForm.a.themeList" :key="item.id">
						<i>{{index + 1}}</i>
						<div class="header-cls">
							<el-input v-model="item.name" placeholder="请输入节点标题" size="mini"></el-input>
							<div class="other">
								<!-- <el-button type="text">
									<svg-icon icon-class="KnowAppendix" />
									插入附件
								</el-button> -->
								<el-upload
									action=""
									:http-request="(file) => { return httpRequestFile(file, index)}"
									:file-list="item.appendixList"
									:show-file-list="false"
									accept="
										image/png, 
										image/jpg, 
										image/jpeg, 
										image/bmp, 
										image/PNG, 
										image/JPG, 
										image/JPEG, 
										image/BMP,
										.PDF
										.pdf,
										.rar,
										.zip,
										.xls,
										.xlsx,
										.docx,
										.doc">
									<el-button type="text">
										<svg-icon icon-class="KnowAppendix" />
										插入附件
									</el-button>
								</el-upload>
								<el-checkbox v-model="item.isSpeak">提示话术</el-checkbox>
								<el-checkbox @change="(e) => {return handleRecordChange(e, item, index)}" v-model="item.isRecord">记录</el-checkbox>
								<svg-icon @click.stop="handleDeleteA(index)" v-show="touchInForm.a.themeList.length > 1" icon-class="KnowClose" />
							</div>
						</div>
						<div class="speak-cls" v-if="item.isSpeak">
							<el-button type="text"> 
								<svg-icon icon-class="Knowxz" />
								提示话术：
							</el-button>
							<el-input v-model="item.speak" placeholder="请输入提示话术" maxlength="80" show-word-limit size="mini" clearable></el-input>
						</div>
						<div class="welfare-text-cls">
							<WelfareText :qaValue="item.welfareText" @childByValue="(res) => { return childByValue(res, index)}" />
						</div>
						<div class="appendix-cls" v-if="item.appendixList.length > 0">
							<el-button type="text"> 
								<svg-icon icon-class="KnowAppendix" />
								附件<small style="color:red;"> ({{item.appendixList.length}}/5)</small> ：
							</el-button>
							<div class="context-cls">
								<div class="cell-cls" v-for="(file, i) in item.appendixList" :key="i">
									<span>{{file.name}}</span>
									<svg-icon @click.stop="handleDeleteAppendix(index, i, file)" icon-class="KnowClose" />
								</div>
							</div>
						</div>
						<div class="jump-cls">
							<el-radio-group v-model="item.isJumpOption">
								<el-radio :label="false">无条件跳转</el-radio>
								<el-radio :label="true">按选项跳转</el-radio>
							</el-radio-group>
							<svg-icon @click.stop="handleAddJumpOption(index)" v-if="item.isJumpOption" style="margin-left: 15px;color: #337EFF;cursor: pointer;" icon-class="KnowAdd2" />
							<div v-if="item.isJumpOption" class="option-cls">
								<draggable v-model="item.jumpOption" handle=".drag" animation="100">
									<div class="option-cell-cls" v-for="(_item, _index) in item.jumpOption" :key="_item.id">
										<svg-icon class="Drag" icon-class="KnowDrag" />
										<span class="label">选项{{_index + 1}}</span>
										<el-input v-model="_item.name" placeholder="选项标题" size="mini" maxlength="20" show-word-limit clearable></el-input>
										<el-select v-model="_item.nextId" collapse-tags placeholder="跳转节点" size="mini">
											<el-option label="结束流程" key="" value=""></el-option>
											<span v-for="__item in touchInForm.a.themeList" :key="__item.id">
												<el-option
													:key="__item.id"
													:label="__item.name"
													:value="__item.id"
													v-if="__item.id !== item.id && __item.name && __item.name != ''">
												</el-option>
											</span>
										</el-select>
										<svg-icon @click.stop="handleDeleteJumpOption(index, _index)" v-show="item.jumpOption.length > 2" icon-class="KnowDelete" />
									</div>
								</draggable>
							</div>
							<el-select v-else v-model="item.nextId" collapse-tags placeholder="请选择要跳转的节点" size="mini">
								<span v-for="(__item, __index) in touchInForm.a.themeList" :key="__item.id">
									<el-option
										:key="__item.id"
										:label="__index+1 + ' ' +__item.name"
										:value="__item.id"
										v-if="__item.id !== item.id && __item.name && __item.name != ''">
									</el-option>
								</span>
								<el-option label="结束流程" key="" value=""></el-option>
							</el-select>
						</div>
						<div class="record-cls" v-if="item.isRecord">
							<div class="header">
								<span>记录：</span>
								<svg-icon @click.stop="handleAddRecordOption(index)" style="margin-left: 15px;color: #337EFF;cursor: pointer;" icon-class="KnowAdd2" />
							</div>
							<div class="option-cls">
								<draggable v-model="item.recordOption" handle=".drag" animation="100">
									<div class="option-cell-cls" v-for="(_item, _index) in item.recordOption" :key="_item.id">
										<svg-icon class="Drag" icon-class="KnowDrag" />
										<el-input v-model="_item.name" placeholder="记录字段" size="mini" maxlength="10" show-word-limit clearable></el-input>
										<svg-icon @click.stop="handleDeleteRecordOption(index, _index)" v-show="item.recordOption.length > 1" icon-class="KnowDelete" />
										<el-input v-model="_item.value" type="textarea" disabled :rows="2" placeholder="记录内容" size="mini" maxlength="1000" show-word-limit clearable></el-input>
									</div>
								</draggable>
							</div>
						</div>
					</div>
				</template>
			</el-form-item>
			<el-form-item v-if="currentNode.type == '2'">
				<div @click.stop="handleNext" class="next-cls"><svg-icon icon-class="KnowAdd2" /> 添加节点</div>
			</el-form-item>
			<el-divider></el-divider>
			<el-form-item style="text-align: right;">
				<el-button @click.stop="handleSubmit(null, 'edit')" :loading="loading" size="mini" type="primary">{{(currentNode.right == 1 && userInfo.userType == 0) ? '提交修改' : '提 交'}}</el-button>
				<el-button @click.stop="handleSubmit('preview')" size="mini">预览</el-button>
				<el-button @click.stop="handleClose" size="mini">取 消</el-button>
			</el-form-item>
		</el-form>
		<el-drawer
			size="60%"
			title="预览"
			:modal="false"
			:modal-append-to-body="false"
			:withHeader="false"
			:visible.sync="drawerKnowledge">
			<!-- <KnowInfoReview sourceType="InfoReview" :row="touchInFormView" /> -->
			<KnowInfoReview v-if="drawerKnowledge" :touchInForm="touchInFormView" sourceType="TouchIn" @drawerKnowInfoClose="drawerKnowledge = false;" />
		</el-drawer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import WelfareText from './WelfareText';
import KnowInfoReview from './KnowInfo';
// import KnowInfoReview from '../KnowInfo/Info';
export default {
	name: 'KnowledgeTouchIn',
	props: ['currentNode', 'drawerType', 'qaId', 'currentNodeNameList'],
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			isProd: process.env.NODE_ENV === 'production',
			drawerKnowledge: false,
			loading: false,
			touchInForm: {
				id: '',
				projectId: '',
				resourceId: '',
				treeId: '',
				type: '',
				status: '1',
				push: '0',
				relationIds: [],
				q: '',
				a: {
					appendixList: [],
					welfareText: '',
					themeList: [],
					businessCategories: ''
				},
				ashort: ''
			},
			themeListIds: [],
			themeListIdDelete: '',
			relationList: [],
			touchInFormView: {}
		}
	},
	created() {
		console.log(this.currentNode)
		if(this.drawerType === 'create' && this.currentNode.type == '2') {
			this.handleNext();
		} else if(this.drawerType === 'update') {
			this.getQaDetail();
		}
	},
	methods: {
		httpRequestFile(file, index){
			if((file?.file?.size / 1024 / 1024) > 20) {
				this.$message.error('附件大于20M，请重新上传');
				return;
			}
			const formData = new FormData();
			formData.append("brand", this.currentNode.projectId);
			formData.append("servicename", 'knowledge');
			formData.append("cdn", this.isProd ? '1' : '0');
			formData.append('file', file.file);
			this.$api.apiPostUploadFile(formData).then(response => {
				if(response.errcode != 0) return;
				if(this.currentNode.type == '1') {
					this.touchInForm.a.appendixList.push({
						name: response.data.name,
						url: response.data.urlMark
					});
				} else {
					if(this.touchInForm.a.themeList[index]['appendixList'].length === 5) {
						this.$message.warning(`附件上传上限5个，已超出限制`);
						return;
					}
					this.touchInForm.a.themeList[index]['appendixList'].push({
						name: response.data.name,
						url: response.data.urlMark
					});
				}
			});
		},
		handleDeleteAppendix(index, i, file) {
			this.$confirm(`确定移除 ${file.name} ?`, '系统提示', {
				type: 'warning'
			}).then(() => {
				this.touchInForm.a.themeList[index]['appendixList'].splice(i, 1);
			}).catch(() => {});
		},
		handleRemove(file, fileList) {
			this.touchInForm.a.appendixList = fileList;
		},
		handleExceed(files, fileList,) {
			this.$message.warning(`附件上传上限5个，已超出限制`);
		},
		beforeRemove(file) {
			return this.$confirm(`确定移除 ${file.name}`, '系统提示', {type: 'warning'});
		},
		handleRecordChange(e, item, index) {
			if(e) {
				if(!item?.recordOption) {
					this.$set(item, 'recordOption', [
						{
							id: this.generateUUID(),
							name: '',
							value: ''
						}
					]);
				}
			}
		},
		getQaDetail() {
			this.themeListIds = [];
			this.$api.apiPostKnowledgeQAInfo({projectId: this.currentNode.projectId, id: this.qaId}).then(response => {
				if(response.errcode != 0) return;
				const data = response.data;
				this.touchInForm.projectId = data.projectId;
				this.touchInForm.resourceId = data.resourceId;
				this.touchInForm.treeId = data.treeId;
				this.touchInForm.type = data.type;
				this.touchInForm.relationIds = data.relationIds ? data.relationIds.split(',') : [];
				this.touchInForm.q = data.q;
				this.touchInForm.a = data.a ? JSON.parse(data.a) : {};
				this.touchInForm.ashort = data.ashort;
				this.touchInForm.id = data.id;
				this.touchInForm.status = data.status;
				this.touchInForm.push = data.push;
				this.relationList = data.relationQA;
				for(const item of this.touchInForm.a.themeList) {
					this.themeListIds.push(item.id);
				}
			});
		},
		childByValue(data, index) {
			if(this.currentNode.type == '1') {
				this.touchInForm.a.welfareText = data.value;
				this.touchInForm.ashort = data.ashort;
			} else {
				this.touchInForm.a.themeList[index].welfareText = data.value;
			}
		},
		remoteMethod(query) {
			if(!query) {
				return;
			}
			this.$api.apiPostKnowledgeSelectQAOnlyList({
				projectId: this.currentNode.projectId,
				resourceId: this.currentNode.resourceId,
				type: this.currentNode.type,
				q: query
			}).then(response => {
				if(response.errcode != 0) return;
				this.relationList = response.data;
			});
		},
		handleNext() {
			const uuid = this.generateUUID();
			this.touchInForm.a.themeList.push({
				id: uuid,
				name: '',
				appendixList: [],
				isSpeak: true,
				speak: '',
				welfareText: '',
				isJumpOption: false,
				nextId: '',
				jumpOption: [
					{
						id: this.generateUUID(),
						name: '',
						nextId: ''
					},
					{
						id: this.generateUUID(),
						name: '',
						nextId: ''
					}
				],
				isSummary: true,
				nextVal: '',
				isRecord: true,
				recordOption: [
					{
						id: this.generateUUID(),
						name: '',
						value: ''
					}
				]
			});
			this.themeListIds.push(uuid);
		},
		handleAddJumpOption(index) {
			this.touchInForm.a.themeList[index].jumpOption.push({
				id: this.generateUUID(),
				name: '',
				nextId: ''
			});
		},
		handleDeleteJumpOption(index, _index) {
			this.touchInForm.a.themeList[index].jumpOption.splice(_index, 1);
		},
		handleAddRecordOption(index) {
			this.touchInForm.a.themeList[index].recordOption.push({
				id: this.generateUUID(),
				name: '',
				value: ''
			});
		},
		handleDeleteRecordOption(index, _index) {
			this.touchInForm.a.themeList[index].recordOption.splice(_index, 1);
		},
		handleDeleteA(index) {
			this.$confirm(`是否删除此节点吗？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.touchInForm.a.themeList.splice(index, 1);
				this.themeListIds.splice(index, 1);
			});
			
		},
		handleSubmit(type, type2) {
			if(!this.touchInForm.q) {
				this.$message.error('标题不能为空');
				return;
			}
			if(this.currentNode.type == '2') {
				for(let i = 0; i < this.touchInForm.a.themeList.length; i++) {
					if(!this.touchInForm.a.themeList[i].name) {
						this.$message.error('节点标题不能为空');
						return;
					}
					if(this.touchInForm.a.themeList[i].isJumpOption) {
						for(const _item of this.touchInForm.a.themeList[i].jumpOption) {
							if(!this.themeListIds.includes(_item.nextId) && _item.nextId) {
								this.$message.error('选项跳转节点已被删除，请重新配置');
								this.themeListIdDelete = this.touchInForm.a.themeList[i].id;
								return;
							}
						}
					} else {
						if(!this.themeListIds.includes(this.touchInForm.a.themeList[i].nextId) && this.touchInForm.a.themeList[i].nextId) {
							this.$message.error('选项跳转节点已被删除，请重新配置');
							this.themeListIdDelete = this.touchInForm.a.themeList[i].id;
							return;
						}
					}
				}
			}
			if(type !== 'preview')this.loading = true;
			if(this.drawerType === 'create') {
				this.touchInForm.projectId = this.currentNode.projectId;
				this.touchInForm.resourceId = this.currentNode.resourceId;
				this.touchInForm.type = this.currentNode.type;
				this.touchInForm.treeId = this.currentNode.treeId;
				if(type === 'preview') {
					this.touchInFormView = JSON.parse(JSON.stringify(this.touchInForm));
					this.drawerKnowledge = true;
					return;
				}
				this.$api.apiPostKnowledgeQaCreate(this.touchInForm).then(response => {
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					this.$message.success('新增成功');
					this.$emit('drawerTouchInClose', true);
				});
			} else {
				if(type === 'preview') {
					this.touchInFormView = JSON.parse(JSON.stringify(this.touchInForm));
					this.drawerKnowledge = true;
					return;
				}
				if(this.currentNode.right == 1 && this.userInfo.userType == 0) {
					this.$prompt(`管理员审核通过后，您的修改将会生效`, `确认：是否提交修改申请`, {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						// inputPattern: /\S/,
						inputType: 'textarea',
						inputShowWordLimit: true,
						inputPlaceholder: '在此可备注修改原因，修改的内容，方便管理员进行审核',
						// inputErrorMessage: '请输入修改原因',
						inputValidator: (value) => {
							if (value == undefined) {
								return '请输入修改原因'
							} else if (value.length > 50) {
								return '输入限制在50个字以内'
							}
						}
					}).then(({ value }) => {
						this.touchInForm['createRemark'] = value;
						this.touchInForm['qaId'] = this.touchInForm.id;
						this.$api.apiPostKnowledgeQATaskApplyQAUpd(this.touchInForm).then(response => {
							if(response.errcode != 0) {
								this.loading = false;
								return;
							}
							this.$message.success('提交成功');
							this.$emit('drawerTouchInClose', true);
						});
					}).catch(() => {
						this.loading = false;
					});
				} else {
					this.$api.apiPostKnowledgeQaUpdate(this.touchInForm).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						}
						this.$message.success('编辑成功');
						this.$emit('drawerTouchInClose', true);
					});
				}
			}
		},
		generateUUID(){
			let d = new Date().getTime();
			let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				let r = (d + Math.random()*16)%16 | 0;
				d = Math.floor(d/16);
				return (c=='x' ? r : (r&0x7|0x8)).toString(16);
			});
			return uuid;
		},
		handleClose() {
			this.$emit('drawerTouchInClose');
		},
	},
	components: {
		WelfareText,
		// KnowInfo,
		KnowInfoReview
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
	font-size: 14px;
	color: #838A9D;
	font-weight: 400;
}

.welfare-text-cls {
	width: 100%;
	// height: 150px;
	border-bottom: solid 1px #D8D8D8;
	box-sizing: border-box;
	overflow: hidden;

	// ::v-deep .ql-toolbar {
	// 	border: none;
	// 	background: #f2f2f2;
	// 	border-bottom: solid 1px #D8D8D8;
	// 	padding: 0;

	// 	& .ql-formats {
	// 		margin-right: 0;
	// 		line-height: 22px;
	// 	}
	// }

	// ::v-deep .ql-container {
	// 	border: none;
	// 	overflow: auto;
	// }

	// & > .count {
	// 	margin-top: 8px;
	// 	color: #909399;
	// 	background: #fff;
	// 	font-size: 12px;
	// 	text-align: right;
	// 	padding-right: 8px;
	// 	box-sizing: border-box;
	// }
}

.touchIn-cls {
	width: 100%;
	height: 100%;
	padding: 20px;
	box-sizing: border-box;
	overflow-x: hidden;
	overflow-y: auto;

	& .title-cls {
		& > span {
			font-size: 20px;
			color: #72767b;
			font-weight: 900;
			margin-right: 16px;
			letter-spacing: 1px;
		}

		& > .svg-icon {
			float: right;
			margin-top: 12px;
			cursor: pointer;
		}
	}

	& .classification {
		font-size: 14px;
		color: #3C4353;
		line-height: 36px;
	}

	& .cell {
		width: 100%;
		// height: 300px;
		border: 1px solid #D8D8D8;
		border-radius: 4px;
		margin-top: 6px;
		padding-bottom: 10px;
		box-sizing: border-box;
		position: relative;

		&.error-tips {
			border-color: #f56c6c;
		}

		& > .header-cls {
			width: 100%;
			height: 36px;
			border-bottom: solid 1px #D8D8D8;
			padding: 0 13px;
			box-sizing: border-box;

			& > .svg-icon {
				font-size: 14px;
				vertical-align: top;
				margin-top: 6.5px;
				margin-right: 6px;
			}

			& > .el-input {
				width: calc(100% - 300px);
				vertical-align: top;
				height: 24px;
				margin-top: 5.5px;
				font-size: 14px;
				font-weight: 500;
				color: #3C4353;

				::v-deep input {
					height: 24px;
					vertical-align: top;
					border: none;
					padding: 0;
					font-weight: bold;
				}
			}

			& > .other {
				vertical-align: top;
				float: right;
				height: 100%;
				padding: 6px 0;
				box-sizing: border-box;

				& > div {
					display: inline-block;
				}

				::v-deep .el-button {
					padding: 0;
					margin-right: 8px;
					font-size: 14px;
					font-weight: 400;
					color: #838A9D;
					vertical-align: top;
					padding-top: 4px;
				}

				::v-deep .el-checkbox {
					vertical-align: top;
					line-height: 24px;
					color: #838A9D;
					margin-right: 8px;
				}

				& > .svg-icon {
					vertical-align: top;
					margin-top: 5px;
					cursor: pointer;
				}
			}
		}

		& > .appendix-cls {
			width: 100%;
			padding: 0 10px;
			box-sizing: border-box;

			::v-deep .el-button {
				padding: 0;
				width: 80px;
				margin-right: 8px;
				font-size: 14px;
				font-weight: 400;
				color: #838A9D;
				vertical-align: top;
				padding-top: 4px;
				cursor: default;
				line-height: 40px;
				text-align: left;
			}

			& > .context-cls {
				display: inline-block;
				width: calc(100% - 88px);
				padding-top: 8px;
				box-sizing: border-box;

				& > .cell-cls {
					width: 100%;
					line-height: 1;
					padding-left: 10px;
					box-sizing: border-box;

					&:hover {
						background: #e6effb;
					}

					& > span {
						width: calc(100% - 30px);
						height: 30px;
						display: inline-block;
						margin-right: 10px;
						overflow:hidden; 
						text-overflow:ellipsis; 
						white-space:nowrap;
						font-size: 14px;
						font-weight: 400;
						color: #838A9D;
						line-height: 30px;
					}

					& > .svg-icon {
						cursor: pointer;
						vertical-align: top;
						margin-top: 10px;
					}
				}
			}
		}

		& > .speak-cls {
			width: 100%;
			height: 50px;
			padding: 0 10px;
			box-sizing: border-box;

			::v-deep .el-button {
				padding: 0;
				width: 80px;
				margin-right: 8px;
				font-size: 14px;
				font-weight: 400;
				color: #838A9D;
				vertical-align: top;
				padding-top: 4px;
				cursor: default;
				line-height: 40px;
				text-align: left;
			}

			::v-deep .el-input {
				width: calc(100% - 90px);
				margin-top: 8px;
			}
		}

		& > .jump-cls {
			width: 100%;
			padding: 0 10px;
			box-sizing: border-box;

			::v-deep .el-button {
				display: block;
				padding: 0;
				margin-right: 8px;
				font-size: 14px;
				font-weight: 400;
				color: #838A9D;
				padding-top: 4px;
				cursor: default;
				line-height: 30px;
			}

			::v-deep .el-radio {
				font-size: 14px;
				font-weight: 400;
				color: #838A9D;
			}

			::v-deep .el-select {
				display: block;
				width: 300px;
			}

			& > .option-cls {
				width: 100%;

				& .option-cell-cls {
					width: 100%;
					height: 24px;
					font-size: 12px;
					font-weight: 400;
					color: #838A9D;
					line-height: 24px;
					margin-bottom: 6px;

					& > .svg-icon {
						margin-right: 5px;
						cursor: move;

						&:nth-of-type(2) {
							cursor: pointer;
						}
					}

					& > .label {
						color: #337EFF;
					}

					::v-deep .el-input {
						display: inline-block;
						width: 150px;
						height: 24px;
						margin-left: 5px;

						& > input {
							height: 24px;
						}
					}

					::v-deep .el-select {
						width: 150px;
						height: 24px;
						display: inline-block;
						margin-right: 15px;
					}
				}
			}
		}

		& > .record-cls {
			width: 100%;
			padding: 0 10px;
			box-sizing: border-box;
			border-top: 1px solid #D8D8D8;
			margin-top: 10px;

			& > .header {
				width: 100%;
				height: 30px;
				line-height: 30px;

				& > span {
					font-size: 14px;
					font-weight: 400;
					color: #838A9D;
				}

				& > .svg-icon {
					margin: 0 !important;
				}
			}

			& > .option-cls {
				width: 100%;

				& .option-cell-cls {
					width: 100%;
					color: #838A9D;
					margin-bottom: 6px;

					& > .svg-icon {
						margin-right: 5px;
						cursor: move;

						&:nth-of-type(2) {
							cursor: pointer;
						}
					}

					::v-deep .el-input {
						display: inline-block;
						width: 150px;
						height: 24px;
						margin: 0 5px;

						& > input {
							height: 24px;
						}

						&:nth-of-type(2) {
							margin-right: 15px;
						}
					}

					::v-deep .el-textarea {
						width: calc(100% - 22px);
						position: relative;
						left: 22px;
					}
				}
			}
		}

		&::before {
			content: "";
			width: 1px;
			height: 100%;
			background: #337EFF;
			position: absolute;
			top: 24px;
			left: -24px;
		}

		&:last-child::before {
			display: none;
		}

		& > i {
			display: inline-block;
			text-align: center;
			font-style: normal;
			width: 24px;
			height: 24px;
			background: #337EFF;
			color: #fff;
			font-size: 14px;
			line-height: 24px;
			border-radius: 50%;
			position: absolute;
			top: 3px;
			left: -36px;
		}
	}

	& .next-cls {
		background: #337EFF;
		border-radius: 4px;
		border: 1px solid #E6E9EF;
		width: 100%;
		height: 32px;
		line-height: 32px;
		font-size: 12px;
		font-weight: 400;
		color: #fff;
		line-height: 32px;
		letter-spacing: 2px;
		cursor: pointer;
		text-align: center;

		&:hover {
			// color: #337EFF;
			border-color: #337EFF;
		}
	}
}
</style>